import React from "react";

class SectionBalance extends React.Component {
  render() {
    return (
      <div>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-66c3a286 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="66c3a286"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-797288f0"
              data-id="797288f0"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-656efc5a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="656efc5a"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-3a74e7f5"
                      data-id="3a74e7f5"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-24959b7a elementor-widget elementor-widget-heading"
                          data-id="24959b7a"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h2 className="elementor-heading-title elementor-size-default">
                              Quer consultar seu Saldo e Indicações?
                            </h2>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-60bff2e2 elementor-align-center elementor-tablet-align-center elementor-mobile-align-center elementor-widget elementor-widget-button"
                          data-id="60bff2e2"
                          data-element_type="widget"
                          data-widget_type="button.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-button-wrapper">
                              <a
                                className="elementor-button elementor-button-link elementor-size-sm"
                                href="https://app.sigmobi.com"
                              >
                                <span className="elementor-button-content-wrapper">
                                  <span className="elementor-button-text">
                                    Escritório Virtual
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-565f706e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="565f706e"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-6414db78"
                      data-id="6414db78"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-56f32feb elementor-widget elementor-widget-heading"
                          data-id="56f32feb"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h6 className="elementor-heading-title elementor-size-default">
                              *Você será redirecionado para consultar seu saldo
                              e indicações
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-7bde9014 elementor-hidden-desktop elementor-hidden-tablet elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="7bde9014"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6fffb0b0"
              data-id="6fffb0b0"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-4d9a6be0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="4d9a6be0"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-65e41057"
                      data-id="65e41057"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-39c54da7 elementor-widget elementor-widget-heading"
                          data-id="39c54da7"
                          data-element_type="widget"
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <h3 className="elementor-heading-title elementor-size-default">
                              Quer consultar seu Saldo e Indicações?
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-18e537b6"
                      data-id="18e537b6"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7b2f4bd6 elementor-align-right elementor-tablet-align-center elementor-widget elementor-widget-button"
                          data-id="7b2f4bd6"
                          data-element_type="widget"
                          data-widget_type="button.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-button-wrapper">
                              <a
                                className="elementor-button elementor-button-link elementor-size-sm"
                                href="#"
                              >
                                <span className="elementor-button-content-wrapper">
                                  <span className="elementor-button-text">
                                    Get started now
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}


export default SectionBalance;